(function(){
  'use strict';
  var ready = function(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };

  ready(function(){
    /* ---- mobile menu ---- */
    var burger = document.querySelector('[data-burger]');
    var drop = document.querySelector('[data-mdrop]');
    if (burger && drop) {
      burger.addEventListener('click', function(){
        var open = drop.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      drop.addEventListener('click', function(e){
        if (e.target.tagName === 'A') { drop.classList.remove('is-open'); burger.setAttribute('aria-expanded','false'); }
      });
    }

    /* ---- hero image cycling ---- */
    var hero = document.querySelector('[data-hero]');
    if (hero) {
      var bg = hero.querySelector('[data-hero-bg]');
      var bgM = hero.querySelector('[data-hero-bg-mobile]');
      var siteHeader = document.querySelector('.site-header');
      var overlaid = document.body.classList.contains('template-index');
      var syncHeader = function(s){
        if (!siteHeader || !s || overlaid) return;
        if (s.bg) siteHeader.style.backgroundColor = s.bg;
        if (s.img) siteHeader.style.backgroundImage = 'url(' + s.img + ')';
      };
      var badge = hero.querySelector('[data-hero-badge]');
      var slides = [];
      try { slides = JSON.parse(hero.getAttribute('data-hero') || '[]'); } catch(e){ slides = []; }
      if (slides.length) {
        siteHeader && (siteHeader.style.transition = 'background-color .6s ease');
        syncHeader(slides[0]);
      }
      if (slides.length > 1) {
        var i = 0;
        setInterval(function(){
          i = (i + 1) % slides.length;
          var s = slides[i];
          bg.style.opacity = '0';
          if (bgM) bgM.style.opacity = '0';
          setTimeout(function(){
            if (s.img) bg.style.backgroundImage = 'url(' + s.img + ')';
            if (bgM && s.mimg) bgM.style.backgroundImage = 'url(' + s.mimg + ')';
            if (s.bg) hero.style.backgroundColor = s.bg;
            if (badge && s.badge) {
              var bs = badge.firstElementChild || badge;
              bs.textContent = '\u26A1\u00A0' + s.badge;
            }
            if (badge && s.accent) badge.style.backgroundColor = s.accent;
            syncHeader(s);
            bg.style.opacity = '1';
            if (bgM) bgM.style.opacity = '1';
          }, 380);
        }, 10000);
      }
    }

    /* ---- letter magnify on hero headline ---- */
    var magnifyTitles = [].slice.call(document.querySelectorAll('[data-magnify]'));
    if (magnifyTitles.length && window.matchMedia('(min-width: 821px)').matches) magnifyTitles.forEach(function(title){
      var letters = [].slice.call(title.querySelectorAll('.l'));
      var centers = null, queued = false, mx = 0, my = 0;
      var measure = function(){
        centers = letters.map(function(el){
          var prev = el.style.transform;
          el.style.transform = 'none';
          var r = el.getBoundingClientRect();
          el.style.transform = prev;
          return { x: r.left + r.width / 2 + window.scrollX, y: r.top + r.height / 2 + window.scrollY };
        });
      };
      var paint = function(){
        queued = false;
        if (!centers) measure();
        var px = mx + window.scrollX, py = my + window.scrollY;
        for (var i = 0; i < letters.length; i++) {
          var c = centers[i];
          var dx = px - c.x, dy = py - c.y;
          var f = Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) / 190);
          letters[i].style.transform = f > 0.01
            ? 'translateY(' + (-24 * f).toFixed(2) + 'px) scale(' + (1 + 0.5 * f).toFixed(3) + ')'
            : 'none';
        }
      };
      title.addEventListener('mousemove', function(e){
        mx = e.clientX; my = e.clientY;
        if (!queued) { queued = true; requestAnimationFrame(paint); }
      }, { passive: true });
      title.addEventListener('mouseleave', function(){
        letters.forEach(function(el){ el.style.transform = 'none'; });
      });
      window.addEventListener('resize', function(){ centers = null; }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ centers = null; });
    });

    /* ---- typewriter titles ---- */
    function typeInto(el){
      var plain = el.getAttribute('data-type-plain') || '';
      var plain2 = el.getAttribute('data-type-plain2') || '';
      var accent = el.getAttribute('data-type-accent') || '';
      var speed = parseInt(el.getAttribute('data-type-speed') || '45', 10);
      var pEl = el.querySelector('[data-type-p]');
      var p2El = el.querySelector('[data-type-p2]');
      var aEl = el.querySelector('[data-type-a]');
      if (!pEl || !aEl) return;
      pEl.textContent = ''; aEl.textContent = '';
      if (p2El) p2El.textContent = '';
      var n = 0, total = plain.length + plain2.length + accent.length;
      var t = setInterval(function(){
        n++;
        pEl.textContent = plain.slice(0, Math.min(n, plain.length));
        var after1 = n - plain.length;
        if (p2El) p2El.textContent = after1 > 0 ? plain2.slice(0, Math.min(after1, plain2.length)) : '';
        var after2 = n - plain.length - plain2.length;
        aEl.textContent = after2 > 0 ? accent.slice(0, after2) : '';
        if (n >= total) clearInterval(t);
      }, speed);
    }
    var typers = [].slice.call(document.querySelectorAll('[data-type-plain]'));
    if (typers.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(en){ if (en.isIntersecting) typeInto(en.target); });
        }, { threshold: 0.35 });
        typers.forEach(function(el){ io.observe(el); });
      } else { typers.forEach(typeInto); }
    }

    /* ---- multi-line typewriter (story quote) ---- */
    var story = document.querySelector('[data-story-type]');
    if (story) {
      var lines = [].slice.call(story.querySelectorAll('[data-line]'));
      var pills = document.querySelectorAll('[data-story-pill]');
      var texts = lines.map(function(l){ return l.getAttribute('data-line'); });
      var runStory = function(){
        lines.forEach(function(l){ l.textContent = ''; });
        pills.forEach(function(p){ p.style.opacity = '0'; p.style.transform = 'translateY(10px)'; });
        var li = 0;
        var next = function(){
          if (li >= lines.length) {
            pills.forEach(function(p, idx){
              setTimeout(function(){ p.style.transition = 'opacity .4s ease, transform .4s ease'; p.style.opacity = '1'; p.style.transform = 'none'; }, idx * 60);
            });
            return;
          }
          var el = lines[li], txt = texts[li], c = 0;
          var t = setInterval(function(){
            c++; el.textContent = txt.slice(0, c);
            if (c >= txt.length) { clearInterval(t); li++; setTimeout(next, 90); }
          }, 34);
        };
        next();
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(en){ if (en[0].isIntersecting) runStory(); }, { threshold: 0.3 }).observe(story);
      } else { runStory(); }
    }

    /* ---- lineup card hover: scale + neighbour shift ---- */
    var cardRows = [].slice.call(document.querySelectorAll('[data-hover-row]'));
    cardRows.forEach(function(row){
      var items = [].slice.call(row.children);
      if (!window.matchMedia('(min-width: 821px)').matches) return;
      var lineupSec = row.closest('.lineup');
      items.forEach(function(item, idx){
        item.addEventListener('mouseenter', function(){
          if (lineupSec) lineupSec.classList.toggle('is-first-hover', idx === 0);
          items.forEach(function(other, j){
            if (j === idx) { other.style.transform = 'scale(1.1)'; other.style.zIndex = '5'; other.style.boxShadow = '0 18px 50px rgba(0,0,0,.55)'; }
            else {
              var dir = j < idx ? -1 : 1;
              var last = items.length - 1;
              var shift = (idx === 0 && j > 0) ? 1 : (idx === last && j < last) ? -1 : dir;
              other.style.transform = 'translateX(' + (shift * 14) + 'px) scale(0.97)';
              other.style.zIndex = '1'; other.style.boxShadow = 'none';
            }
          });
        });
      });
      row.addEventListener('mouseleave', function(){
        if (lineupSec) lineupSec.classList.remove('is-first-hover');
        items.forEach(function(el){ el.style.transform = 'none'; el.style.zIndex = '1'; el.style.boxShadow = 'none'; });
      });
    });

    /* ---- info tabs: only one open, hover on desktop, click on touch ---- */
    var tabsWrap = document.querySelector('[data-tabs]');
    if (tabsWrap) {
      var btns = [].slice.call(tabsWrap.querySelectorAll('[data-tab]'));
      var panels = [].slice.call(tabsWrap.querySelectorAll('[data-panel]'));
      var isDesktop = function(){ return window.matchMedia('(min-width: 821px)').matches; };
      var current = null;
      function show(name){
        current = name;
        panels.forEach(function(p){ p.classList.toggle('is-open', p.getAttribute('data-panel') === name); });
        btns.forEach(function(b){ b.setAttribute('aria-expanded', b.getAttribute('data-tab') === name ? 'true' : 'false'); });
        if (name) {
          var open = tabsWrap.querySelector('[data-panel="' + name + '"] [data-panel-title]');
          if (open) { open.style.opacity = '0'; open.style.transform = 'translateY(10px)';
            requestAnimationFrame(function(){ open.style.transition = 'opacity .45s ease, transform .45s ease'; open.style.opacity = '1'; open.style.transform = 'none'; }); }
        }
      }
      function close(){
        current = null;
        panels.forEach(function(p){ p.classList.remove('is-open'); });
        btns.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
        tabsWrap.querySelectorAll('.faq__item').forEach(function(i){ i.classList.remove('is-open'); });
      }
      btns.forEach(function(b){
        var name = b.getAttribute('data-tab');
        b.addEventListener('click', function(){ current === name ? close() : show(name); });
        b.addEventListener('mouseenter', function(){ if (isDesktop() && !current) show(name); });
      });
      tabsWrap.addEventListener('mouseleave', function(){ if (isDesktop()) close(); });
      var openFromHash = function(scroll){
        var deep = (location.hash || '').replace('#', '');
        if (!deep || !tabsWrap.querySelector('[data-panel="' + deep + '"]')) return false;
        show(deep);
        if (scroll !== false) {
          var y = tabsWrap.getBoundingClientRect().top + window.scrollY - 40;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        return true;
      };
      openFromHash();
      window.addEventListener('hashchange', function(){ openFromHash(); });

      // links elsewhere on the page (nav, footer) open the matching panel
      document.addEventListener('click', function(e){
        var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
        if (!a) return;
        var frag = a.getAttribute('href').split('#')[1];
        if (!frag || !tabsWrap.querySelector('[data-panel="' + frag + '"]')) return;
        var path = a.getAttribute('href').split('#')[0];
        if (path && path !== '/' && path !== location.pathname) return;
        e.preventDefault();
        if (location.hash !== '#' + frag) history.replaceState(null, '', '#' + frag);
        show(frag);
        var y = tabsWrap.getBoundingClientRect().top + window.scrollY - 40;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }

    /* ---- popup footer dock + scroll progress ---- */
    var dock = document.querySelector('[data-footer-dock]');
    var sentinel = document.querySelector('[data-footer-sentinel]');
    var fill = document.querySelector('[data-scroll-fill]');
    if (dock) {
      var pill = dock.querySelector('.footer-dock__pill');
      if (pill) pill.addEventListener('click', function(){ dock.classList.toggle('is-open'); });
      var onDockScroll = function(){
        if (sentinel) {
          var docked = sentinel.getBoundingClientRect().top <= window.innerHeight;
          dock.classList.toggle('is-docked', docked);
          if (docked) dock.classList.remove('is-open');
        }
        if (fill) {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          fill.style.width = (max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0) + '%';
        }
      };
      window.addEventListener('scroll', onDockScroll, { passive: true });
      window.addEventListener('resize', onDockScroll, { passive: true });
      onDockScroll();
    }

    /* ---- accordions (info tabs + product detail rows) ---- */
    document.addEventListener('click', function(e){
      var q = e.target.closest && e.target.closest('.faq__q');
      if (!q) return;
      var item = q.closest('.faq__item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      item.parentNode.querySelectorAll('.faq__item').forEach(function(i){
        i.classList.remove('is-open');
        var b = i.querySelector('.faq__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      item.parentNode.querySelectorAll('.faq__sign').forEach(function(s){ s.textContent = '+'; });
      if (!wasOpen) {
        item.classList.add('is-open');
        q.setAttribute('aria-expanded', 'true');
        var sign = item.querySelector('.faq__sign');
        if (sign) sign.textContent = '\u2212';
      }
    });

    /* ---- product gallery ---- */
    var gal = document.querySelector('[data-gallery]');
    if (gal) {
      var main = gal.querySelector('[data-gallery-main]');
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){
        btn.addEventListener('click', function(){
          main.src = btn.getAttribute('data-src');
          var frame = main.parentNode;
          if (frame) frame.classList.toggle('is-nutrition', btn.classList.contains('is-nutrition'));
          gal.querySelectorAll('[data-gallery-thumb]').forEach(function(b){ b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
        });
      });
    }

    /* ---- variant picker ---- */
    var vForm = document.querySelector('[data-variant-form]');
    if (vForm) {
      var variants = [];
      try { variants = JSON.parse(vForm.getAttribute('data-variants') || '[]'); } catch(e){}
      var idInput = vForm.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-variant-price]');
      var submit = vForm.querySelector('[data-variant-submit]');
      var packThumbs = [].slice.call(document.querySelectorAll('[data-pack]'));
      var galMain = document.querySelector('[data-gallery-main]');
      var firstSrc = galMain ? galMain.getAttribute('src') : '';
      var showPack = function(title){
        if (!packThumbs.length) return;
        var t = (title || '').toLowerCase();
        var want = '';
        if (t.indexOf('mix') > -1) {
          want = t.indexOf('8') > -1 ? 'mixed8' : 'mixed4';
        } else if (t.indexOf('8') > -1) {
          want = 'single8';
        }
        var active = null;
        packThumbs.forEach(function(b){
          var on = b.getAttribute('data-pack') === want;
          b.hidden = !on;
          if (on) active = b;
        });
        if (active && galMain) {
          galMain.src = active.getAttribute('data-src');
          document.querySelectorAll('[data-gallery-thumb]').forEach(function(b){
            b.setAttribute('aria-current', b === active ? 'true' : 'false');
          });
        } else if (!want && galMain && firstSrc) {
          galMain.src = firstSrc;
          document.querySelectorAll('[data-gallery-thumb]').forEach(function(b, i){
            b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          });
        }
      };
      var update = function(){
        var chosen = [].slice.call(vForm.querySelectorAll('input[type=radio]:checked')).map(function(r){ return r.value; });
        var match = variants.filter(function(v){ return v.options.join('|') === chosen.join('|'); })[0];
        if (!match) match = variants[0];
        if (!match) return;
        idInput.value = match.id;
        if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
        if (submit) {
          submit.disabled = !match.available;
          var label = match.available ? submit.getAttribute('data-label-add') : submit.getAttribute('data-label-sold');
          if (match.available && match.price_formatted) label += ' \u2014 ' + match.price_formatted;
          submit.textContent = label;
        }
        showPack(match.title);
      };
      vForm.querySelectorAll('input[type=radio]').forEach(function(r){ r.addEventListener('change', update); });
      var qn = vForm.querySelector('.qty__n');
      vForm.querySelectorAll('[data-qty]').forEach(function(b){
        b.addEventListener('click', function(){
          var next = (parseInt(qn.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
          qn.value = next < 1 ? 1 : next;
        });
      });
      update();
    }
  });
})();
